var _circle, _mask, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyModule(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#61E5E9"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 96,
    height: 96
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54.9998,
    cy: 55,
    r: 47.0619,
    fill: "#73E5FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 54.9998,
    cy: 55,
    r: 47.0619,
    fill: "#39E4B9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.0825,
    y: 38.5566,
    width: 58.9691,
    height: 32.8866,
    rx: 9.07216,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.1502 51.5928L39.1803 51.5604C40.4905 50.1524 40.4754 47.8786 39.1502 46.4949C37.8475 47.8948 37.8324 50.1524 39.12 51.5604L39.1502 51.5928Z",
    fill: "url(#empty0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.629 55.7196L47.5988 55.6873C46.2886 54.2793 44.1727 54.2955 42.8851 55.7196C44.1877 57.1195 46.2886 57.1357 47.5988 55.752L47.629 55.7196Z",
    fill: "url(#empty1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3626 55.6063L35.3324 55.574C34.0222 54.166 31.9063 54.1822 30.6187 55.6063C31.9213 57.0062 34.0222 57.0224 35.3324 55.6387L35.3626 55.6063Z",
    fill: "url(#empty2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8986 52.8227H41.9363C43.7887 52.7985 45.257 51.1558 45.2118 49.1733C43.3745 49.1976 41.8986 50.8078 41.8986 52.7823V52.8227Z",
    fill: "url(#empty3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7932 58.4142C41.8083 60.4048 43.3218 61.9908 45.1666 61.9504C45.1516 59.976 43.6682 58.3738 41.8233 58.3657H41.7932V58.4142Z",
    fill: "url(#empty4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5372 58.3009H36.4996C34.6472 58.2848 33.1487 59.895 33.1563 61.8856C34.9936 61.9018 36.4996 60.3239 36.5297 58.3495L36.5372 58.3009Z",
    fill: "url(#empty5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3641 52.8632V52.8227C36.3866 50.8402 34.9032 49.2137 33.0508 49.2137C33.0283 51.1882 34.4891 52.8227 36.3264 52.8632H36.3641Z",
    fill: "url(#empty6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1502 57.516C40.1025 57.516 40.8745 56.6864 40.8745 55.663C40.8745 54.6396 40.1025 53.8099 39.1502 53.8099C38.1978 53.8099 37.4258 54.6396 37.4258 55.663C37.4258 56.6864 38.1978 57.516 39.1502 57.516Z",
    fill: "url(#empty7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8053 56.8363H38.5101L37.5312 62.3712H40.8519L39.8053 56.8363Z",
    fill: "url(#empty8_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.165,
    y: 47.6289,
    width: 26.0825,
    height: 2.26804,
    rx: 1.13402,
    fill: "#E9E9EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.165,
    y: 53.299,
    width: 24.9485,
    height: 2.26804,
    rx: 1.13402,
    fill: "#E9E9EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.165,
    y: 58.9691,
    width: 17.0103,
    height: 2.26804,
    rx: 1.13402,
    fill: "#E9E9EB"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -37.4229,
    y: 38.5566,
    width: 58.9691,
    height: 32.8866,
    rx: 9.07216,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -11.3403,
    y: 47.6289,
    width: 26.0825,
    height: 2.26804,
    rx: 1.13402,
    fill: "#E9E9EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -11.3403,
    y: 53.299,
    width: 24.9485,
    height: 2.26804,
    rx: 1.13402,
    fill: "#E9E9EB"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.5874,
    y: 38.5566,
    width: 58.9691,
    height: 32.8866,
    rx: 9.07216,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.655 51.5928L102.685 51.5604C103.995 50.1524 103.98 47.8786 102.655 46.4949C101.352 47.8948 101.337 50.1524 102.625 51.5604L102.655 51.5928Z",
    fill: "url(#empty9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.134 55.7196L111.104 55.6873C109.794 54.2793 107.678 54.2955 106.39 55.7196C107.693 57.1195 109.794 57.1357 111.104 55.752L111.134 55.7196Z",
    fill: "url(#empty10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8674 55.6063L98.8373 55.574C97.5271 54.166 95.4112 54.1822 94.1235 55.6063C95.4262 57.0062 97.5271 57.0224 98.8373 55.6387L98.8674 55.6063Z",
    fill: "url(#empty11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.404 52.8227H105.441C107.294 52.7985 108.762 51.1558 108.717 49.1733C106.879 49.1976 105.404 50.8078 105.404 52.7823V52.8227Z",
    fill: "url(#empty12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.298 58.4142C105.313 60.4048 106.827 61.9908 108.672 61.9504C108.656 59.976 107.173 58.3738 105.328 58.3657H105.298V58.4142Z",
    fill: "url(#empty13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.042 58.3009H100.004C98.1521 58.2848 96.6536 59.895 96.6612 61.8856C98.4985 61.9018 100.004 60.3239 100.035 58.3495L100.042 58.3009Z",
    fill: "url(#empty14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8689 52.8632V52.8227C99.8915 50.8402 98.4081 49.2137 96.5557 49.2137C96.5331 51.1882 97.994 52.8227 99.8313 52.8632H99.8689Z",
    fill: "url(#empty15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.655 57.516C103.607 57.516 104.379 56.6864 104.379 55.663C104.379 54.6396 103.607 53.8099 102.655 53.8099C101.703 53.8099 100.931 54.6396 100.931 55.663C100.931 56.6864 101.703 57.516 102.655 57.516Z",
    fill: "url(#empty16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.31 56.8363H102.015L101.036 62.3712H104.357L103.31 56.8363Z",
    fill: "url(#empty17_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 15.8763,
    y: 29.4845,
    width: 79.3814,
    height: 53.299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.13402
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.10309
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: -47.629,
    y: 29.4845,
    width: 79.3814,
    height: 53.299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.13402
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.10309
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 79.3812,
    y: 29.4845,
    width: 79.3814,
    height: 53.299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.13402
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.10309
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty0_linear",
    x1: 43.9761,
    y1: 54.2443,
    x2: 34.5231,
    y2: 54.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty1_linear",
    x1: 43.9761,
    y1: 54.2443,
    x2: 34.5231,
    y2: 54.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty2_linear",
    x1: 43.9761,
    y1: 54.2443,
    x2: 34.5231,
    y2: 54.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty3_linear",
    x1: 43.9761,
    y1: 54.2443,
    x2: 34.5231,
    y2: 54.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty4_linear",
    x1: 43.9761,
    y1: 54.2443,
    x2: 34.5231,
    y2: 54.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty5_linear",
    x1: 43.9761,
    y1: 54.2443,
    x2: 34.5231,
    y2: 54.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty6_linear",
    x1: 43.9761,
    y1: 54.2443,
    x2: 34.5231,
    y2: 54.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty7_linear",
    x1: 43.9761,
    y1: 54.2443,
    x2: 34.5231,
    y2: 54.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty8_linear",
    x1: 43.9761,
    y1: 54.2443,
    x2: 34.5231,
    y2: 54.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty9_linear",
    x1: 107.481,
    y1: 54.2443,
    x2: 98.028,
    y2: 54.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty10_linear",
    x1: 107.481,
    y1: 54.2443,
    x2: 98.028,
    y2: 54.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty11_linear",
    x1: 107.481,
    y1: 54.2443,
    x2: 98.028,
    y2: 54.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty12_linear",
    x1: 107.481,
    y1: 54.2443,
    x2: 98.028,
    y2: 54.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty13_linear",
    x1: 107.481,
    y1: 54.2443,
    x2: 98.028,
    y2: 54.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty14_linear",
    x1: 107.481,
    y1: 54.2443,
    x2: 98.028,
    y2: 54.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty15_linear",
    x1: 107.481,
    y1: 54.2443,
    x2: 98.028,
    y2: 54.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty16_linear",
    x1: 107.481,
    y1: 54.2443,
    x2: 98.028,
    y2: 54.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty17_linear",
    x1: 107.481,
    y1: 54.2443,
    x2: 98.028,
    y2: 54.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyModule);
export default __webpack_public_path__ + "static/media/empty-module.de6b83c6.svg";
export { ForwardRef as ReactComponent };